/** Google Haritalar gömülü harita (dil parametresi). Metinler i18n: `contactPage.*`. */

export const CONTACT_MAP_EMBED_SRC =
    'https://www.google.com/maps?q=Hilton+Istanbul+Bosphorus,+Harbiye,+Şişli,+İstanbul&output=embed&hl=tr&z=16';

export const CONTACT_MAP_EMBED_SRC_EN =
    'https://www.google.com/maps?q=Hilton+Istanbul+Bosphorus,+Harbiye,+Şişli,+İstanbul&output=embed&hl=en&z=16';

export const CONTACT_PHONE_DISPLAY = '0 212 234 04 03';
export const CONTACT_PHONE_HREF = 'tel:+902122340403';

/** Kaynak metinde “Fax” etiketiyle verilmiş; değer e-posta adresidir. */
export const CONTACT_EMAIL = 'rotary@istanbulrotary.org';

/**
 * i18n `contactPage.socialGroups` (returnObjects).
 * @param {unknown} raw
 * @returns {Array<{ id: string, network: 'facebook' | 'x', label: string, href: string }>}
 */
export function mapContactSocialGroupsFromI18n(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .filter((x) => x && typeof x === 'object')
        .map((x) => {
            const o = /** @type {Record<string, unknown>} */ (x);
            const network = o.network === 'x' ? 'x' : 'facebook';
            return {
                id: String(o.id ?? ''),
                network,
                href: String(o.href ?? ''),
                label: String(o.label ?? ''),
            };
        })
        .filter((g) => g.id && g.href && g.label);
}
